import { useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { printerSelectors, printManager } from '@provider/print';
import { TanstackQueryProvider, ComponentFrameworkContextMenu } from '@utils/component-framework';
import { convertIGuideHtmlToLatex } from '../ast/util.html-to-latex.js';
import { prepareIGuidePrint } from '../print.pdf/util.prepare-print.js';
import { WordPrintLayoutContent } from '../print.word/organism.print.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useShareIGuideEntryMutation } from '../state/mutation.share-entry.js';

function IGuideContextMenu(props) {
  const shareEntryWithTeacherMutation = useShareIGuideEntryMutation();
  const onShareWithTeacher = () => {
    props.onShareWithTeacher?.();
    shareEntryWithTeacherMutation(props.component.entryKey);
  };
  const getPrintInput = useMemo(() => format => new Promise(resolve => {
    if (format === "pdf") {
      prepareIGuidePrint(props.component, "export-service").finally(() => {
        resolve(document.querySelector(printerSelectors.container()) ?? document.body);
      });
      return;
    }
    const onReady = () => {
      resolve(convertIGuideHtmlToLatex(fragment.querySelector("div[data-root]")?.innerHTML ?? ""));
      setTimeout(() => {
        root.unmount();
      });
    };
    const fragment = document.createDocumentFragment();
    const root = createRoot(fragment);
    root.render(/*#__PURE__*/jsx(TanstackQueryProvider, {
      children: /*#__PURE__*/jsx("div", {
        "data-root": true,
        ref: onReady,
        children: /*#__PURE__*/jsx(WordPrintLayoutContent, {
          component: props.component
        })
      })
    }));
  }), [props.component]);
  const onPrint = async () => {
    await prepareIGuidePrint(props.component, "browser");
    printManager.triggerPrintDialog();
  };
  return /*#__PURE__*/jsxs(ComponentFrameworkContextMenu, {
    className: props.className,
    axis: "horisontal",
    nodeId: props.nodeId,
    layout: props.layout,
    enabled: props.enabled,
    children: [/*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "export",
      printOrientation: "portrait",
      componentTitle: props.component.envelope.Title,
      input: getPrintInput
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "drive",
      format: "docx",
      componentTitle: props.component.envelope.Title,
      entryKey: props.component.entryKey,
      input: getPrintInput,
      printOrientation: "portrait"
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "print",
      onClick: onPrint
    }), /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
      type: "share",
      entryKey: props.component.entryKey,
      onShareWithTeacher: onShareWithTeacher
    }), props.children]
  });
}

export { IGuideContextMenu };
//# sourceMappingURL=integration.context-menu.js.map
